module.exports = __webpack_public_path__ + "a217e580785f179ca8c65e849cc7fce6.svg";